<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Descripcion -->
      <v-col cols="12" sm="10" md="10">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción:"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Estado -->
      <v-col cols="12" sm="2" md="2">
        <v-switch
          v-model="editedItem.Estado"
          color="red-darken-3"
          label="Estado"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Parametros 1 -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Param1"
          label="Parámetro 1:"
          clearable
          dense
          maxlength="10"
          counter="10"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Parametros 2 -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Param2"
          label="Parámetro 2:"
          clearable
          dense
          maxlength="10"
          counter="10"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Url -->
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="editedItem.LinkValue"
          :items="ArrayUrl"
          :item-title="(ArrayUrl) => ArrayUrl.IDLink + '-' + ArrayUrl.Url"
          item-value="IDLink"
          color="primary"
          label="Url:"
          dense
          clearable
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { putUpdate, postInsert } from "@/views/TCI/Seguridad/Links/LinksServices";
import { getConsultAllList } from "@/views/TCI/Seguridad/Url/UrlServices";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";

export default {
  name: "datos-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        IDLink: 0,
        Param1: null,
        Param2: null,
        Descripcion: null,
        LinkValue: null,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        IDLink: 0,
        Param1: null,
        Param2: null,
        Descripcion: null,
        LinkValue: null,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
      ArrayUrl: [],
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Consulta Url
    async getUrl() {
      this.ArrayUrl = [];
      const result = await getConsultAllList();
      this.ArrayUrl = result;
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.getUrl();
    this.ActualizarCargue();
  },
};
</script>
